import { render, staticRenderFns } from "./ImsCustomersWidget.vue?vue&type=template&id=11ab689c&"
import script from "./ImsCustomersWidget.vue?vue&type=script&lang=js&"
export * from "./ImsCustomersWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports